import React, { useState } from 'react';
import { Form, Button, Alert, Spinner } from 'react-bootstrap';
import api from './api';

function SifreDegistirModal({ onComplete, onLogout }) {
  const [yeniSifre, setYeniSifre] = useState('');
  const [yeniSifreTekrar, setYeniSifreTekrar] = useState('');
  const [mevcutSifre, setMevcutSifre] = useState('');
  // Zorunlu ilk değişimde mevcut şifre sorulmaz. Sunucu yine de isterse
  // (ör. bayrak zaten güncellenmişse) alan görünür olur, kullanıcı kilitlenmez.
  const [mevcutSifreGerekli, setMevcutSifreGerekli] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (yeniSifre.length < 8) {
      setError('Şifre en az 8 karakter olmalıdır.');
      return;
    }
    if (yeniSifre !== yeniSifreTekrar) {
      setError('Şifreler eşleşmiyor.');
      return;
    }
    if (mevcutSifreGerekli && !mevcutSifre) {
      setError('Mevcut şifrenizi girmeniz gerekmektedir.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const govde = { yeni_sifre: yeniSifre };
      if (mevcutSifreGerekli && mevcutSifre) {
        govde.mevcut_sifre = mevcutSifre;
      }
      await api.post('/sifre-degistir', govde);
      localStorage.setItem('sifreDegistirildi', 'true');
      onComplete();
    } catch (err) {
      const mesaj = err.response?.data?.mesaj || 'Şifre değiştirilemedi.';
      if (/mevcut şifre/i.test(mesaj)) {
        setMevcutSifreGerekli(true);
      }
      setError(mesaj);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.85)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div className="p-4 rounded-4 shadow-lg" style={{ width: '420px', maxWidth: '95%', backgroundColor: 'var(--bg-secondary)', border: '1px solid var(--border-color)' }}>
        <div className="text-center mb-4">
          <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3" style={{ width: '60px', height: '60px', backgroundColor: 'rgba(245,158,11,0.15)' }}>
            <span className="material-symbols-outlined" style={{ fontSize: '30px', color: '#f59e0b' }}>lock_reset</span>
          </div>
          <h4 className="fw-bolder" style={{ color: 'var(--text-main)' }}>Şifre Değiştirme Zorunlu</h4>
          <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>Demo hesabınız için ilk girişte şifrenizi değiştirmeniz gerekmektedir.</p>
        </div>

        <Form onSubmit={handleSubmit}>
          {mevcutSifreGerekli && (
            <Form.Group className="mb-3">
              <Form.Label style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>Mevcut Şifre</Form.Label>
              <Form.Control type="password" value={mevcutSifre} onChange={(e) => setMevcutSifre(e.target.value)} autoFocus placeholder="Giriş yaptığınız şifre" style={{ backgroundColor: 'transparent', color: 'var(--text-main)', border: '1px solid var(--border-color)' }} />
            </Form.Group>
          )}
          <Form.Group className="mb-3">
            <Form.Label style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>Yeni Şifre</Form.Label>
            <Form.Control type="password" value={yeniSifre} onChange={(e) => setYeniSifre(e.target.value)} required placeholder="En az 8 karakter" style={{ backgroundColor: 'transparent', color: 'var(--text-main)', border: '1px solid var(--border-color)' }} />
          </Form.Group>
          <Form.Group className="mb-4">
            <Form.Label style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>Yeni Şifre (Tekrar)</Form.Label>
            <Form.Control type="password" value={yeniSifreTekrar} onChange={(e) => setYeniSifreTekrar(e.target.value)} required placeholder="Şifreyi tekrar girin" style={{ backgroundColor: 'transparent', color: 'var(--text-main)', border: '1px solid var(--border-color)' }} />
          </Form.Group>

          {error && <Alert variant="danger" className="mb-3">{error}</Alert>}

          <div className="d-grid">
            <Button type="submit" className="fw-bold py-2" disabled={loading} style={{ background: 'linear-gradient(135deg, #6de039, #266d00)', border: 'none' }}>
              {loading ? <Spinner as="span" animation="border" size="sm" /> : 'Şifreyi Değiştir'}
            </Button>
          </div>

          {onLogout && (
            <div className="text-center mt-3">
              <Button variant="link" size="sm" onClick={onLogout} disabled={loading} style={{ color: 'var(--text-muted)', textDecoration: 'none' }}>
                Vazgeç ve çıkış yap
              </Button>
            </div>
          )}
        </Form>
      </div>
    </div>
  );
}

export default SifreDegistirModal;
